import { useState, useEffect } from 'react'

export default function useTooltipControl({ listToShow = [] }) {
	// data
	const nameList = 'TOOLTIP_LIST'
	const [listTooltip, setListTooltip] = useState(
		localStorage.getItem(nameList) ? [...localStorage.getItem(nameList).split(',')] : []
	)
	const [showToolTip, setShowToolTip] = useState(false)

	// actions
	const handledSetListActive = newIdItem => {
		const validateElementsInLocal = localStorage.getItem(nameList)
			? [...localStorage.getItem(nameList).split(',')]
			: []
		const newLits = [...new Set([...validateElementsInLocal, ...listTooltip, newIdItem])]
		setListTooltip(newLits)
		localStorage.setItem(nameList, newLits)
	}

	const setShowElement = list => {
		const filterToSelect = list.filter(e => !listTooltip.includes(e))

		setShowToolTip(filterToSelect[0] || false)
	}

	useEffect(() => {
		if (listToShow.length === 0) return

		setShowElement(listToShow)
	}, [listToShow])

	return {
		listTooltip,
		showToolTip,
		// actions
		handledSetListActive
	}
}
